import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Search, Shield, Zap } from 'lucide-react';

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="py-4 px-4 border-b border-slate-700">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold text-white">OSINT Search</h1>
          <Button
            onClick={() => navigate('/dashboard')}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Open App
          </Button>
        </div>
      </header>

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 py-20">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6">
            Discover Connected Identities
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">
            Search social media and dating profiles by reverse email, username, or mobile lookup. Get enriched results instantly.
          </p>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-slate-800 border border-slate-700 rounded-lg p-8">
            <Search className="w-12 h-12 text-blue-400 mb-4" />
            <h3 className="text-lg font-semibold text-white mb-2">Multiple Search Types</h3>
            <p className="text-slate-300">Search by email, username, or mobile number</p>
          </div>
          <div className="bg-slate-800 border border-slate-700 rounded-lg p-8">
            <Shield className="w-12 h-12 text-green-400 mb-4" />
            <h3 className="text-lg font-semibold text-white mb-2">Secure & Private</h3>
            <p className="text-slate-300">Your searches are processed locally</p>
          </div>
          <div className="bg-slate-800 border border-slate-700 rounded-lg p-8">
            <Zap className="w-12 h-12 text-yellow-400 mb-4" />
            <h3 className="text-lg font-semibold text-white mb-2">Instant Results</h3>
            <p className="text-slate-300">Get enriched data across multiple platforms</p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            size="lg"
            onClick={() => navigate('/dashboard')}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Start Searching
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Index;